var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75 4.25H4.25C3.85218 4.25 3.47064 4.40804 3.18934 4.68934C2.90804 4.97064 2.75 5.35218 2.75 5.75V19.25C2.75 19.6478 2.90804 20.0294 3.18934 20.3107C3.47064 20.592 3.85218 20.75 4.25 20.75H20.75C21.1478 20.75 21.5294 20.592 21.8107 20.3107C22.092 20.0294 22.25 19.6478 22.25 19.25V5.75C22.25 5.35218 22.092 4.97064 21.8107 4.68934C21.5294 4.40804 21.1478 4.25 20.75 4.25ZM15.125 8.75C15.3475 8.75 15.565 8.81598 15.75 8.9396C15.935 9.06321 16.0792 9.23891 16.1644 9.44448C16.2495 9.65005 16.2718 9.87625 16.2284 10.0945C16.185 10.3127 16.0778 10.5132 15.9205 10.6705C15.7632 10.8278 15.5627 10.935 15.3445 10.9784C15.1262 11.0218 14.9 10.9995 14.6945 10.9144C14.4889 10.8292 14.3132 10.685 14.1896 10.5C14.066 10.315 14 10.0975 14 9.875C14 9.57663 14.1185 9.29048 14.3295 9.0795C14.5405 8.86853 14.8266 8.75 15.125 8.75ZM4.25 19.25V16.625L9.125 11.75L16.625 19.25H4.25ZM20.75 19.25H18.7466L15.3716 15.875L17.2466 14L20.75 17.5044V19.25Z",
    fill: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedImage);
export default __webpack_public_path__ + "static/media/selected-image.5f9419772df9186af4845b80a73593bc.svg";
export { ForwardRef as ReactComponent };